import React, { useEffect, useRef, useState } from "react";
import "./AboutVideo.css";

function AboutVideo() {
    const videoRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const currentVideo = videoRef.current;
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    setIsVisible(entry.isIntersecting);
                });
            },
            { threshold: 0.5 } // El video se activa cuando el 50% es visible
        );

        if (currentVideo) {
            observer.observe(currentVideo);
        }

        return () => {
            if (currentVideo) {
                observer.unobserve(currentVideo);
            }
        };
    }, []);

    return (
        <div className="about-video" ref={videoRef}>
            <iframe
                src={`https://www.youtube.com/embed/IjYElVyKGJU?autoplay=${isVisible ? 1 : 0}&mute=1`}
                title="Mi historia en QA"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
            ></iframe>
        </div>
    );
}

export default AboutVideo;
